export const REST_OF_WORLD = 'Rest of world';
export const ANY_SHIPPING_METHOD = 'Any shipping method';

export const continentCode = {
  AF: 'Africa',
  NA: 'North America',
  OC: 'Oceania',
  AN: 'Antarctica',
  AS: 'Asia',
  EU: 'Europe',
  SA: 'South Africa',
};

export const allCountryData = [
  {
    name: 'Andorra',
    native: 'Andorra',
    phone: '376',
    continent: 'EU',
    capital: 'Andorra la Vella',
    currency: 'EUR',
    languages: ['ca'],
    code: 'AD',
  },
  {
    name: 'United Arab Emirates',
    native: 'دولة الإمارات العربية المتحدة',
    phone: '971',
    continent: 'AS',
    capital: 'Abu Dhabi',
    currency: 'AED',
    languages: ['ar'],
    code: 'AE',
  },
  {
    name: 'Afghanistan',
    native: 'افغانستان',
    phone: '93',
    continent: 'AS',
    capital: 'Kabul',
    currency: 'AFN',
    languages: ['ps', 'uz', 'tk'],
    code: 'AF',
  },
  {
    name: 'Antigua and Barbuda',
    native: 'Antigua and Barbuda',
    phone: '1268',
    continent: 'NA',
    capital: "Saint John's",
    currency: 'XCD',
    languages: ['en'],
    code: 'AG',
  },
  {
    name: 'Anguilla',
    native: 'Anguilla',
    phone: '1264',
    continent: 'NA',
    capital: 'The Valley',
    currency: 'XCD',
    languages: ['en'],
    code: 'AI',
  },
  {
    name: 'Albania',
    native: 'Shqipëria',
    phone: '355',
    continent: 'EU',
    capital: 'Tirana',
    currency: 'ALL',
    languages: ['sq'],
    code: 'AL',
  },
  {
    name: 'Armenia',
    native: 'Հայաստան',
    phone: '374',
    continent: 'AS',
    capital: 'Yerevan',
    currency: 'AMD',
    languages: ['hy', 'ru'],
    code: 'AM',
  },
  {
    name: 'Angola',
    native: 'Angola',
    phone: '244',
    continent: 'AF',
    capital: 'Luanda',
    currency: 'AOA',
    languages: ['pt'],
    code: 'AO',
  },
  {
    name: 'Antarctica',
    native: 'Antarctica',
    phone: '672',
    continent: 'AN',
    capital: '',
    currency: '',
    languages: [],
    code: 'AQ',
  },
  {
    name: 'Argentina',
    native: 'Argentina',
    phone: '54',
    continent: 'SA',
    capital: 'Buenos Aires',
    currency: 'ARS',
    languages: ['es', 'gn'],
    code: 'AR',
  },
  {
    name: 'American Samoa',
    native: 'American Samoa',
    phone: '1684',
    continent: 'OC',
    capital: 'Pago Pago',
    currency: 'USD',
    languages: ['en', 'sm'],
    code: 'AS',
  },
  {
    name: 'Austria',
    native: 'Österreich',
    phone: '43',
    continent: 'EU',
    capital: 'Vienna',
    currency: 'EUR',
    languages: ['de'],
    code: 'AT',
  },
  {
    name: 'Australia',
    native: 'Australia',
    phone: '61',
    continent: 'OC',
    capital: 'Canberra',
    currency: 'AUD',
    languages: ['en'],
    code: 'AU',
  },
  {
    name: 'Aruba',
    native: 'Aruba',
    phone: '297',
    continent: 'NA',
    capital: 'Oranjestad',
    currency: 'AWG',
    languages: ['nl', 'pa'],
    code: 'AW',
  },
  {
    name: 'Åland',
    native: 'Åland',
    phone: '358',
    continent: 'EU',
    capital: 'Mariehamn',
    currency: 'EUR',
    languages: ['sv'],
    code: 'AX',
  },
  {
    name: 'Azerbaijan',
    native: 'Azərbaycan',
    phone: '994',
    continent: 'AS',
    capital: 'Baku',
    currency: 'AZN',
    languages: ['az'],
    code: 'AZ',
  },
  {
    name: 'Bosnia and Herzegovina',
    native: 'Bosna i Hercegovina',
    phone: '387',
    continent: 'EU',
    capital: 'Sarajevo',
    currency: 'BAM',
    languages: ['bs', 'hr', 'sr'],
    code: 'BA',
  },
  {
    name: 'Barbados',
    native: 'Barbados',
    phone: '1246',
    continent: 'NA',
    capital: 'Bridgetown',
    currency: 'BBD',
    languages: ['en'],
    code: 'BB',
  },
  {
    name: 'Bangladesh',
    native: 'Bangladesh',
    phone: '880',
    continent: 'AS',
    capital: 'Dhaka',
    currency: 'BDT',
    languages: ['bn'],
    code: 'BD',
  },
  {
    name: 'Belgium',
    native: 'België',
    phone: '32',
    continent: 'EU',
    capital: 'Brussels',
    currency: 'EUR',
    languages: ['nl', 'fr', 'de'],
    code: 'BE',
  },
  {
    name: 'Burkina Faso',
    native: 'Burkina Faso',
    phone: '226',
    continent: 'AF',
    capital: 'Ouagadougou',
    currency: 'XOF',
    languages: ['fr', 'ff'],
    code: 'BF',
  },
  {
    name: 'Bulgaria',
    native: 'България',
    phone: '359',
    continent: 'EU',
    capital: 'Sofia',
    currency: 'BGN',
    languages: ['bg'],
    code: 'BG',
  },
  {
    name: 'Bahrain',
    native: '‏البحرين',
    phone: '973',
    continent: 'AS',
    capital: 'Manama',
    currency: 'BHD',
    languages: ['ar'],
    code: 'BH',
  },
  {
    name: 'Burundi',
    native: 'Burundi',
    phone: '257',
    continent: 'AF',
    capital: 'Bujumbura',
    currency: 'BIF',
    languages: ['fr', 'rn'],
    code: 'BI',
  },
  {
    name: 'Benin',
    native: 'Bénin',
    phone: '229',
    continent: 'AF',
    capital: 'Porto-Novo',
    currency: 'XOF',
    languages: ['fr'],
    code: 'BJ',
  },
  {
    name: 'Saint Barthélemy',
    native: 'Saint-Barthélemy',
    phone: '590',
    continent: 'NA',
    capital: 'Gustavia',
    currency: 'EUR',
    languages: ['fr'],
    code: 'BL',
  },
  {
    name: 'Bermuda',
    native: 'Bermuda',
    phone: '1441',
    continent: 'NA',
    capital: 'Hamilton',
    currency: 'BMD',
    languages: ['en'],
    code: 'BM',
  },
  {
    name: 'Brunei',
    native: 'Negara Brunei Darussalam',
    phone: '673',
    continent: 'AS',
    capital: 'Bandar Seri Begawan',
    currency: 'BND',
    languages: ['ms'],
    code: 'BN',
  },
  {
    name: 'Bolivia',
    native: 'Bolivia',
    phone: '591',
    continent: 'SA',
    capital: 'Sucre',
    currency: 'BOB,BOV',
    languages: ['es', 'ay', 'qu'],
    code: 'BO',
  },
  {
    name: 'Bonaire',
    native: 'Bonaire',
    phone: '5997',
    continent: 'NA',
    capital: 'Kralendijk',
    currency: 'USD',
    languages: ['nl'],
    code: 'BQ',
  },
  {
    name: 'Brazil',
    native: 'Brasil',
    phone: '55',
    continent: 'SA',
    capital: 'Brasília',
    currency: 'BRL',
    languages: ['pt'],
    code: 'BR',
  },
  {
    name: 'Bahamas',
    native: 'Bahamas',
    phone: '1242',
    continent: 'NA',
    capital: 'Nassau',
    currency: 'BSD',
    languages: ['en'],
    code: 'BS',
  },
  {
    name: 'Bhutan',
    native: 'ʼbrug-yul',
    phone: '975',
    continent: 'AS',
    capital: 'Thimphu',
    currency: 'BTN,INR',
    languages: ['dz'],
    code: 'BT',
  },
  {
    name: 'Bouvet Island',
    native: 'Bouvetøya',
    phone: '47',
    continent: 'AN',
    capital: '',
    currency: 'NOK',
    languages: ['no', 'nb', 'nn'],
    code: 'BV',
  },
  {
    name: 'Botswana',
    native: 'Botswana',
    phone: '267',
    continent: 'AF',
    capital: 'Gaborone',
    currency: 'BWP',
    languages: ['en', 'tn'],
    code: 'BW',
  },
  {
    name: 'Belarus',
    native: 'Белару́сь',
    phone: '375',
    continent: 'EU',
    capital: 'Minsk',
    currency: 'BYN',
    languages: ['be', 'ru'],
    code: 'BY',
  },
  {
    name: 'Belize',
    native: 'Belize',
    phone: '501',
    continent: 'NA',
    capital: 'Belmopan',
    currency: 'BZD',
    languages: ['en', 'es'],
    code: 'BZ',
  },
  {
    name: 'Canada',
    native: 'Canada',
    phone: '1',
    continent: 'NA',
    capital: 'Ottawa',
    currency: 'CAD',
    languages: ['en', 'fr'],
    code: 'CA',
  },
  {
    name: 'Cocos [Keeling] Islands',
    native: 'Cocos (Keeling) Islands',
    phone: '61',
    continent: 'AS',
    capital: 'West Island',
    currency: 'AUD',
    languages: ['en'],
    code: 'CC',
  },
  {
    name: 'Democratic Republic of the Congo',
    native: 'République démocratique du Congo',
    phone: '243',
    continent: 'AF',
    capital: 'Kinshasa',
    currency: 'CDF',
    languages: ['fr', 'ln', 'kg', 'sw', 'lu'],
    code: 'CD',
  },
  {
    name: 'Central African Republic',
    native: 'Ködörösêse tî Bêafrîka',
    phone: '236',
    continent: 'AF',
    capital: 'Bangui',
    currency: 'XAF',
    languages: ['fr', 'sg'],
    code: 'CF',
  },
  {
    name: 'Republic of the Congo',
    native: 'République du Congo',
    phone: '242',
    continent: 'AF',
    capital: 'Brazzaville',
    currency: 'XAF',
    languages: ['fr', 'ln'],
    code: 'CG',
  },
  {
    name: 'Switzerland',
    native: 'Schweiz',
    phone: '41',
    continent: 'EU',
    capital: 'Bern',
    currency: 'CHE,CHF,CHW',
    languages: ['de', 'fr', 'it'],
    code: 'CH',
  },
  {
    name: 'Ivory Coast',
    native: "Côte d'Ivoire",
    phone: '225',
    continent: 'AF',
    capital: 'Yamoussoukro',
    currency: 'XOF',
    languages: ['fr'],
    code: 'CI',
  },
  {
    name: 'Cook Islands',
    native: 'Cook Islands',
    phone: '682',
    continent: 'OC',
    capital: 'Avarua',
    currency: 'NZD',
    languages: ['en'],
    code: 'CK',
  },
  {
    name: 'Chile',
    native: 'Chile',
    phone: '56',
    continent: 'SA',
    capital: 'Santiago',
    currency: 'CLF,CLP',
    languages: ['es'],
    code: 'CL',
  },
  {
    name: 'Cameroon',
    native: 'Cameroon',
    phone: '237',
    continent: 'AF',
    capital: 'Yaoundé',
    currency: 'XAF',
    languages: ['en', 'fr'],
    code: 'CM',
  },
  {
    name: 'China',
    native: '中国',
    phone: '86',
    continent: 'AS',
    capital: 'Beijing',
    currency: 'CNY',
    languages: ['zh'],
    code: 'CN',
  },
  {
    name: 'Colombia',
    native: 'Colombia',
    phone: '57',
    continent: 'SA',
    capital: 'Bogotá',
    currency: 'COP',
    languages: ['es'],
    code: 'CO',
  },
  {
    name: 'Costa Rica',
    native: 'Costa Rica',
    phone: '506',
    continent: 'NA',
    capital: 'San José',
    currency: 'CRC',
    languages: ['es'],
    code: 'CR',
  },
  {
    name: 'Cuba',
    native: 'Cuba',
    phone: '53',
    continent: 'NA',
    capital: 'Havana',
    currency: 'CUC,CUP',
    languages: ['es'],
    code: 'CU',
  },
  {
    name: 'Cape Verde',
    native: 'Cabo Verde',
    phone: '238',
    continent: 'AF',
    capital: 'Praia',
    currency: 'CVE',
    languages: ['pt'],
    code: 'CV',
  },
  {
    name: 'Curacao',
    native: 'Curaçao',
    phone: '5999',
    continent: 'NA',
    capital: 'Willemstad',
    currency: 'ANG',
    languages: ['nl', 'pa', 'en'],
    code: 'CW',
  },
  {
    name: 'Christmas Island',
    native: 'Christmas Island',
    phone: '61',
    continent: 'AS',
    capital: 'Flying Fish Cove',
    currency: 'AUD',
    languages: ['en'],
    code: 'CX',
  },
  {
    name: 'Cyprus',
    native: 'Κύπρος',
    phone: '357',
    continent: 'EU',
    capital: 'Nicosia',
    currency: 'EUR',
    languages: ['el', 'tr', 'hy'],
    code: 'CY',
  },
  {
    name: 'Czech Republic',
    native: 'Česká republika',
    phone: '420',
    continent: 'EU',
    capital: 'Prague',
    currency: 'CZK',
    languages: ['cs', 'sk'],
    code: 'CZ',
  },
  {
    name: 'Germany',
    native: 'Deutschland',
    phone: '49',
    continent: 'EU',
    capital: 'Berlin',
    currency: 'EUR',
    languages: ['de'],
    code: 'DE',
  },
  {
    name: 'Djibouti',
    native: 'Djibouti',
    phone: '253',
    continent: 'AF',
    capital: 'Djibouti',
    currency: 'DJF',
    languages: ['fr', 'ar'],
    code: 'DJ',
  },
  {
    name: 'Denmark',
    native: 'Danmark',
    phone: '45',
    continent: 'EU',
    capital: 'Copenhagen',
    currency: 'DKK',
    languages: ['da'],
    code: 'DK',
  },
  {
    name: 'Dominica',
    native: 'Dominica',
    phone: '1767',
    continent: 'NA',
    capital: 'Roseau',
    currency: 'XCD',
    languages: ['en'],
    code: 'DM',
  },
  {
    name: 'Dominican Republic',
    native: 'República Dominicana',
    phone: '1809,1829,1849',
    continent: 'NA',
    capital: 'Santo Domingo',
    currency: 'DOP',
    languages: ['es'],
    code: 'DO',
  },
  {
    name: 'Algeria',
    native: 'الجزائر',
    phone: '213',
    continent: 'AF',
    capital: 'Algiers',
    currency: 'DZD',
    languages: ['ar'],
    code: 'DZ',
  },
  {
    name: 'Ecuador',
    native: 'Ecuador',
    phone: '593',
    continent: 'SA',
    capital: 'Quito',
    currency: 'USD',
    languages: ['es'],
    code: 'EC',
  },
  {
    name: 'Estonia',
    native: 'Eesti',
    phone: '372',
    continent: 'EU',
    capital: 'Tallinn',
    currency: 'EUR',
    languages: ['et'],
    code: 'EE',
  },
  {
    name: 'Egypt',
    native: 'مصر‎',
    phone: '20',
    continent: 'AF',
    capital: 'Cairo',
    currency: 'EGP',
    languages: ['ar'],
    code: 'EG',
  },
  {
    name: 'Western Sahara',
    native: 'الصحراء الغربية',
    phone: '212',
    continent: 'AF',
    capital: 'El Aaiún',
    currency: 'MAD,DZD,MRU',
    languages: ['es'],
    code: 'EH',
  },
  {
    name: 'Eritrea',
    native: 'ኤርትራ',
    phone: '291',
    continent: 'AF',
    capital: 'Asmara',
    currency: 'ERN',
    languages: ['ti', 'ar', 'en'],
    code: 'ER',
  },
  {
    name: 'Spain',
    native: 'España',
    phone: '34',
    continent: 'EU',
    capital: 'Madrid',
    currency: 'EUR',
    languages: ['es', 'eu', 'ca', 'gl', 'oc'],
    code: 'ES',
  },
  {
    name: 'Ethiopia',
    native: 'ኢትዮጵያ',
    phone: '251',
    continent: 'AF',
    capital: 'Addis Ababa',
    currency: 'ETB',
    languages: ['am'],
    code: 'ET',
  },
  {
    name: 'Finland',
    native: 'Suomi',
    phone: '358',
    continent: 'EU',
    capital: 'Helsinki',
    currency: 'EUR',
    languages: ['fi', 'sv'],
    code: 'FI',
  },
  {
    name: 'Fiji',
    native: 'Fiji',
    phone: '679',
    continent: 'OC',
    capital: 'Suva',
    currency: 'FJD',
    languages: ['en', 'fj', 'hi', 'ur'],
    code: 'FJ',
  },
  {
    name: 'Falkland Islands',
    native: 'Falkland Islands',
    phone: '500',
    continent: 'SA',
    capital: 'Stanley',
    currency: 'FKP',
    languages: ['en'],
    code: 'FK',
  },
  {
    name: 'Micronesia',
    native: 'Micronesia',
    phone: '691',
    continent: 'OC',
    capital: 'Palikir',
    currency: 'USD',
    languages: ['en'],
    code: 'FM',
  },
  {
    name: 'Faroe Islands',
    native: 'Føroyar',
    phone: '298',
    continent: 'EU',
    capital: 'Tórshavn',
    currency: 'DKK',
    languages: ['fo'],
    code: 'FO',
  },
  {
    name: 'France',
    native: 'France',
    phone: '33',
    continent: 'EU',
    capital: 'Paris',
    currency: 'EUR',
    languages: ['fr'],
    code: 'FR',
  },
  {
    name: 'Gabon',
    native: 'Gabon',
    phone: '241',
    continent: 'AF',
    capital: 'Libreville',
    currency: 'XAF',
    languages: ['fr'],
    code: 'GA',
  },
  {
    name: 'United Kingdom',
    native: 'United Kingdom',
    phone: '44',
    continent: 'EU',
    capital: 'London',
    currency: 'GBP',
    languages: ['en'],
    code: 'GB',
  },
  {
    name: 'Grenada',
    native: 'Grenada',
    phone: '1473',
    continent: 'NA',
    capital: "St. George's",
    currency: 'XCD',
    languages: ['en'],
    code: 'GD',
  },
  {
    name: 'Georgia',
    native: 'საქართველო',
    phone: '995',
    continent: 'AS',
    capital: 'Tbilisi',
    currency: 'GEL',
    languages: ['ka'],
    code: 'GE',
  },
  {
    name: 'French Guiana',
    native: 'Guyane française',
    phone: '594',
    continent: 'SA',
    capital: 'Cayenne',
    currency: 'EUR',
    languages: ['fr'],
    code: 'GF',
  },
  {
    name: 'Guernsey',
    native: 'Guernsey',
    phone: '44',
    continent: 'EU',
    capital: 'St. Peter Port',
    currency: 'GBP',
    languages: ['en', 'fr'],
    code: 'GG',
  },
  {
    name: 'Ghana',
    native: 'Ghana',
    phone: '233',
    continent: 'AF',
    capital: 'Accra',
    currency: 'GHS',
    languages: ['en'],
    code: 'GH',
  },
  {
    name: 'Gibraltar',
    native: 'Gibraltar',
    phone: '350',
    continent: 'EU',
    capital: 'Gibraltar',
    currency: 'GIP',
    languages: ['en'],
    code: 'GI',
  },
  {
    name: 'Greenland',
    native: 'Kalaallit Nunaat',
    phone: '299',
    continent: 'NA',
    capital: 'Nuuk',
    currency: 'DKK',
    languages: ['kl'],
    code: 'GL',
  },
  {
    name: 'Gambia',
    native: 'Gambia',
    phone: '220',
    continent: 'AF',
    capital: 'Banjul',
    currency: 'GMD',
    languages: ['en'],
    code: 'GM',
  },
  {
    name: 'Guinea',
    native: 'Guinée',
    phone: '224',
    continent: 'AF',
    capital: 'Conakry',
    currency: 'GNF',
    languages: ['fr', 'ff'],
    code: 'GN',
  },
  {
    name: 'Guadeloupe',
    native: 'Guadeloupe',
    phone: '590',
    continent: 'NA',
    capital: 'Basse-Terre',
    currency: 'EUR',
    languages: ['fr'],
    code: 'GP',
  },
  {
    name: 'Equatorial Guinea',
    native: 'Guinea Ecuatorial',
    phone: '240',
    continent: 'AF',
    capital: 'Malabo',
    currency: 'XAF',
    languages: ['es', 'fr'],
    code: 'GQ',
  },
  {
    name: 'Greece',
    native: 'Ελλάδα',
    phone: '30',
    continent: 'EU',
    capital: 'Athens',
    currency: 'EUR',
    languages: ['el'],
    code: 'GR',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    native: 'South Georgia',
    phone: '500',
    continent: 'AN',
    capital: 'King Edward Point',
    currency: 'GBP',
    languages: ['en'],
    code: 'GS',
  },
  {
    name: 'Guatemala',
    native: 'Guatemala',
    phone: '502',
    continent: 'NA',
    capital: 'Guatemala City',
    currency: 'GTQ',
    languages: ['es'],
    code: 'GT',
  },
  {
    name: 'Guam',
    native: 'Guam',
    phone: '1671',
    continent: 'OC',
    capital: 'Hagåtña',
    currency: 'USD',
    languages: ['en', 'ch', 'es'],
    code: 'GU',
  },
  {
    name: 'Guinea-Bissau',
    native: 'Guiné-Bissau',
    phone: '245',
    continent: 'AF',
    capital: 'Bissau',
    currency: 'XOF',
    languages: ['pt'],
    code: 'GW',
  },
  {
    name: 'Guyana',
    native: 'Guyana',
    phone: '592',
    continent: 'SA',
    capital: 'Georgetown',
    currency: 'GYD',
    languages: ['en'],
    code: 'GY',
  },
  {
    name: 'Hong Kong',
    native: '香港',
    phone: '852',
    continent: 'AS',
    capital: 'City of Victoria',
    currency: 'HKD',
    languages: ['zh', 'en'],
    code: 'HK',
  },
  {
    name: 'Heard Island and McDonald Islands',
    native: 'Heard Island and McDonald Islands',
    phone: '61',
    continent: 'AN',
    capital: '',
    currency: 'AUD',
    languages: ['en'],
    code: 'HM',
  },
  {
    name: 'Honduras',
    native: 'Honduras',
    phone: '504',
    continent: 'NA',
    capital: 'Tegucigalpa',
    currency: 'HNL',
    languages: ['es'],
    code: 'HN',
  },
  {
    name: 'Croatia',
    native: 'Hrvatska',
    phone: '385',
    continent: 'EU',
    capital: 'Zagreb',
    currency: 'HRK',
    languages: ['hr'],
    code: 'HR',
  },
  {
    name: 'Haiti',
    native: 'Haïti',
    phone: '509',
    continent: 'NA',
    capital: 'Port-au-Prince',
    currency: 'HTG,USD',
    languages: ['fr', 'ht'],
    code: 'HT',
  },
  {
    name: 'Hungary',
    native: 'Magyarország',
    phone: '36',
    continent: 'EU',
    capital: 'Budapest',
    currency: 'HUF',
    languages: ['hu'],
    code: 'HU',
  },
  {
    name: 'Indonesia',
    native: 'Indonesia',
    phone: '62',
    continent: 'AS',
    capital: 'Jakarta',
    currency: 'IDR',
    languages: ['id'],
    code: 'ID',
  },
  {
    name: 'Ireland',
    native: 'Éire',
    phone: '353',
    continent: 'EU',
    capital: 'Dublin',
    currency: 'EUR',
    languages: ['ga', 'en'],
    code: 'IE',
  },
  {
    name: 'Israel',
    native: 'יִשְׂרָאֵל',
    phone: '972',
    continent: 'AS',
    capital: 'Jerusalem',
    currency: 'ILS',
    languages: ['he', 'ar'],
    code: 'IL',
  },
  {
    name: 'Isle of Man',
    native: 'Isle of Man',
    phone: '44',
    continent: 'EU',
    capital: 'Douglas',
    currency: 'GBP',
    languages: ['en', 'gv'],
    code: 'IM',
  },
  {
    name: 'India',
    native: 'भारत',
    phone: '91',
    continent: 'AS',
    capital: 'New Delhi',
    currency: 'INR',
    languages: ['hi', 'en'],
    code: 'IN',
  },
  {
    name: 'British Indian Ocean Territory',
    native: 'British Indian Ocean Territory',
    phone: '246',
    continent: 'AS',
    capital: 'Diego Garcia',
    currency: 'USD',
    languages: ['en'],
    code: 'IO',
  },
  {
    name: 'Iraq',
    native: 'العراق',
    phone: '964',
    continent: 'AS',
    capital: 'Baghdad',
    currency: 'IQD',
    languages: ['ar', 'ku'],
    code: 'IQ',
  },
  {
    name: 'Iran',
    native: 'ایران',
    phone: '98',
    continent: 'AS',
    capital: 'Tehran',
    currency: 'IRR',
    languages: ['fa'],
    code: 'IR',
  },
  {
    name: 'Iceland',
    native: 'Ísland',
    phone: '354',
    continent: 'EU',
    capital: 'Reykjavik',
    currency: 'ISK',
    languages: ['is'],
    code: 'IS',
  },
  {
    name: 'Italy',
    native: 'Italia',
    phone: '39',
    continent: 'EU',
    capital: 'Rome',
    currency: 'EUR',
    languages: ['it'],
    code: 'IT',
  },
  {
    name: 'Jersey',
    native: 'Jersey',
    phone: '44',
    continent: 'EU',
    capital: 'Saint Helier',
    currency: 'GBP',
    languages: ['en', 'fr'],
    code: 'JE',
  },
  {
    name: 'Jamaica',
    native: 'Jamaica',
    phone: '1876',
    continent: 'NA',
    capital: 'Kingston',
    currency: 'JMD',
    languages: ['en'],
    code: 'JM',
  },
  {
    name: 'Jordan',
    native: 'الأردن',
    phone: '962',
    continent: 'AS',
    capital: 'Amman',
    currency: 'JOD',
    languages: ['ar'],
    code: 'JO',
  },
  {
    name: 'Japan',
    native: '日本',
    phone: '81',
    continent: 'AS',
    capital: 'Tokyo',
    currency: 'JPY',
    languages: ['ja'],
    code: 'JP',
  },
  {
    name: 'Kenya',
    native: 'Kenya',
    phone: '254',
    continent: 'AF',
    capital: 'Nairobi',
    currency: 'KES',
    languages: ['en', 'sw'],
    code: 'KE',
  },
  {
    name: 'Kyrgyzstan',
    native: 'Кыргызстан',
    phone: '996',
    continent: 'AS',
    capital: 'Bishkek',
    currency: 'KGS',
    languages: ['ky', 'ru'],
    code: 'KG',
  },
  {
    name: 'Cambodia',
    native: 'Kâmpŭchéa',
    phone: '855',
    continent: 'AS',
    capital: 'Phnom Penh',
    currency: 'KHR',
    languages: ['km'],
    code: 'KH',
  },
  {
    name: 'Kiribati',
    native: 'Kiribati',
    phone: '686',
    continent: 'OC',
    capital: 'South Tarawa',
    currency: 'AUD',
    languages: ['en'],
    code: 'KI',
  },
  {
    name: 'Comoros',
    native: 'Komori',
    phone: '269',
    continent: 'AF',
    capital: 'Moroni',
    currency: 'KMF',
    languages: ['ar', 'fr'],
    code: 'KM',
  },
  {
    name: 'Saint Kitts and Nevis',
    native: 'Saint Kitts and Nevis',
    phone: '1869',
    continent: 'NA',
    capital: 'Basseterre',
    currency: 'XCD',
    languages: ['en'],
    code: 'KN',
  },
  {
    name: 'North Korea',
    native: '북한',
    phone: '850',
    continent: 'AS',
    capital: 'Pyongyang',
    currency: 'KPW',
    languages: ['ko'],
    code: 'KP',
  },
  {
    name: 'South Korea',
    native: '대한민국',
    phone: '82',
    continent: 'AS',
    capital: 'Seoul',
    currency: 'KRW',
    languages: ['ko'],
    code: 'KR',
  },
  {
    name: 'Kuwait',
    native: 'الكويت',
    phone: '965',
    continent: 'AS',
    capital: 'Kuwait City',
    currency: 'KWD',
    languages: ['ar'],
    code: 'KW',
  },
  {
    name: 'Cayman Islands',
    native: 'Cayman Islands',
    phone: '1345',
    continent: 'NA',
    capital: 'George Town',
    currency: 'KYD',
    languages: ['en'],
    code: 'KY',
  },
  {
    name: 'Kazakhstan',
    native: 'Қазақстан',
    phone: '76,77',
    continent: 'AS',
    capital: 'Astana',
    currency: 'KZT',
    languages: ['kk', 'ru'],
    code: 'KZ',
  },
  {
    name: 'Laos',
    native: 'ສປປລາວ',
    phone: '856',
    continent: 'AS',
    capital: 'Vientiane',
    currency: 'LAK',
    languages: ['lo'],
    code: 'LA',
  },
  {
    name: 'Lebanon',
    native: 'لبنان',
    phone: '961',
    continent: 'AS',
    capital: 'Beirut',
    currency: 'LBP',
    languages: ['ar', 'fr'],
    code: 'LB',
  },
  {
    name: 'Saint Lucia',
    native: 'Saint Lucia',
    phone: '1758',
    continent: 'NA',
    capital: 'Castries',
    currency: 'XCD',
    languages: ['en'],
    code: 'LC',
  },
  {
    name: 'Liechtenstein',
    native: 'Liechtenstein',
    phone: '423',
    continent: 'EU',
    capital: 'Vaduz',
    currency: 'CHF',
    languages: ['de'],
    code: 'LI',
  },
  {
    name: 'Sri Lanka',
    native: 'śrī laṃkāva',
    phone: '94',
    continent: 'AS',
    capital: 'Colombo',
    currency: 'LKR',
    languages: ['si', 'ta'],
    code: 'LK',
  },
  {
    name: 'Liberia',
    native: 'Liberia',
    phone: '231',
    continent: 'AF',
    capital: 'Monrovia',
    currency: 'LRD',
    languages: ['en'],
    code: 'LR',
  },
  {
    name: 'Lesotho',
    native: 'Lesotho',
    phone: '266',
    continent: 'AF',
    capital: 'Maseru',
    currency: 'LSL,ZAR',
    languages: ['en', 'st'],
    code: 'LS',
  },
  {
    name: 'Lithuania',
    native: 'Lietuva',
    phone: '370',
    continent: 'EU',
    capital: 'Vilnius',
    currency: 'EUR',
    languages: ['lt'],
    code: 'LT',
  },
  {
    name: 'Luxembourg',
    native: 'Luxembourg',
    phone: '352',
    continent: 'EU',
    capital: 'Luxembourg',
    currency: 'EUR',
    languages: ['fr', 'de', 'lb'],
    code: 'LU',
  },
  {
    name: 'Latvia',
    native: 'Latvija',
    phone: '371',
    continent: 'EU',
    capital: 'Riga',
    currency: 'EUR',
    languages: ['lv'],
    code: 'LV',
  },
  {
    name: 'Libya',
    native: '‏ليبيا',
    phone: '218',
    continent: 'AF',
    capital: 'Tripoli',
    currency: 'LYD',
    languages: ['ar'],
    code: 'LY',
  },
  {
    name: 'Morocco',
    native: 'المغرب',
    phone: '212',
    continent: 'AF',
    capital: 'Rabat',
    currency: 'MAD',
    languages: ['ar'],
    code: 'MA',
  },
  {
    name: 'Monaco',
    native: 'Monaco',
    phone: '377',
    continent: 'EU',
    capital: 'Monaco',
    currency: 'EUR',
    languages: ['fr'],
    code: 'MC',
  },
  {
    name: 'Moldova',
    native: 'Moldova',
    phone: '373',
    continent: 'EU',
    capital: 'Chișinău',
    currency: 'MDL',
    languages: ['ro'],
    code: 'MD',
  },
  {
    name: 'Montenegro',
    native: 'Црна Гора',
    phone: '382',
    continent: 'EU',
    capital: 'Podgorica',
    currency: 'EUR',
    languages: ['sr', 'bs', 'sq', 'hr'],
    code: 'ME',
  },
  {
    name: 'Saint Martin',
    native: 'Saint-Martin',
    phone: '590',
    continent: 'NA',
    capital: 'Marigot',
    currency: 'EUR',
    languages: ['en', 'fr', 'nl'],
    code: 'MF',
  },
  {
    name: 'Madagascar',
    native: 'Madagasikara',
    phone: '261',
    continent: 'AF',
    capital: 'Antananarivo',
    currency: 'MGA',
    languages: ['fr', 'mg'],
    code: 'MG',
  },
  {
    name: 'Marshall Islands',
    native: 'M̧ajeļ',
    phone: '692',
    continent: 'OC',
    capital: 'Majuro',
    currency: 'USD',
    languages: ['en', 'mh'],
    code: 'MH',
  },
  {
    name: 'North Macedonia',
    native: 'Северна Македонија',
    phone: '389',
    continent: 'EU',
    capital: 'Skopje',
    currency: 'MKD',
    languages: ['mk'],
    code: 'MK',
  },
  {
    name: 'Mali',
    native: 'Mali',
    phone: '223',
    continent: 'AF',
    capital: 'Bamako',
    currency: 'XOF',
    languages: ['fr'],
    code: 'ML',
  },
  {
    name: 'Myanmar [Burma]',
    native: 'မြန်မာ',
    phone: '95',
    continent: 'AS',
    capital: 'Naypyidaw',
    currency: 'MMK',
    languages: ['my'],
    code: 'MM',
  },
  {
    name: 'Mongolia',
    native: 'Монгол улс',
    phone: '976',
    continent: 'AS',
    capital: 'Ulan Bator',
    currency: 'MNT',
    languages: ['mn'],
    code: 'MN',
  },
  {
    name: 'Macao',
    native: '澳門',
    phone: '853',
    continent: 'AS',
    capital: '',
    currency: 'MOP',
    languages: ['zh', 'pt'],
    code: 'MO',
  },
  {
    name: 'Northern Mariana Islands',
    native: 'Northern Mariana Islands',
    phone: '1670',
    continent: 'OC',
    capital: 'Saipan',
    currency: 'USD',
    languages: ['en', 'ch'],
    code: 'MP',
  },
  {
    name: 'Martinique',
    native: 'Martinique',
    phone: '596',
    continent: 'NA',
    capital: 'Fort-de-France',
    currency: 'EUR',
    languages: ['fr'],
    code: 'MQ',
  },
  {
    name: 'Mauritania',
    native: 'موريتانيا',
    phone: '222',
    continent: 'AF',
    capital: 'Nouakchott',
    currency: 'MRU',
    languages: ['ar'],
    code: 'MR',
  },
  {
    name: 'Montserrat',
    native: 'Montserrat',
    phone: '1664',
    continent: 'NA',
    capital: 'Plymouth',
    currency: 'XCD',
    languages: ['en'],
    code: 'MS',
  },
  {
    name: 'Malta',
    native: 'Malta',
    phone: '356',
    continent: 'EU',
    capital: 'Valletta',
    currency: 'EUR',
    languages: ['mt', 'en'],
    code: 'MT',
  },
  {
    name: 'Mauritius',
    native: 'Maurice',
    phone: '230',
    continent: 'AF',
    capital: 'Port Louis',
    currency: 'MUR',
    languages: ['en'],
    code: 'MU',
  },
  {
    name: 'Maldives',
    native: 'Maldives',
    phone: '960',
    continent: 'AS',
    capital: 'Malé',
    currency: 'MVR',
    languages: ['dv'],
    code: 'MV',
  },
  {
    name: 'Malawi',
    native: 'Malawi',
    phone: '265',
    continent: 'AF',
    capital: 'Lilongwe',
    currency: 'MWK',
    languages: ['en', 'ny'],
    code: 'MW',
  },
  {
    name: 'Mexico',
    native: 'México',
    phone: '52',
    continent: 'NA',
    capital: 'Mexico City',
    currency: 'MXN',
    languages: ['es'],
    code: 'MX',
  },
  {
    name: 'Malaysia',
    native: 'Malaysia',
    phone: '60',
    continent: 'AS',
    capital: 'Kuala Lumpur',
    currency: 'MYR',
    languages: ['ms'],
    code: 'MY',
  },
  {
    name: 'Mozambique',
    native: 'Moçambique',
    phone: '258',
    continent: 'AF',
    capital: 'Maputo',
    currency: 'MZN',
    languages: ['pt'],
    code: 'MZ',
  },
  {
    name: 'Namibia',
    native: 'Namibia',
    phone: '264',
    continent: 'AF',
    capital: 'Windhoek',
    currency: 'NAD,ZAR',
    languages: ['en', 'af'],
    code: 'NA',
  },
  {
    name: 'New Caledonia',
    native: 'Nouvelle-Calédonie',
    phone: '687',
    continent: 'OC',
    capital: 'Nouméa',
    currency: 'XPF',
    languages: ['fr'],
    code: 'NC',
  },
  {
    name: 'Niger',
    native: 'Niger',
    phone: '227',
    continent: 'AF',
    capital: 'Niamey',
    currency: 'XOF',
    languages: ['fr'],
    code: 'NE',
  },
  {
    name: 'Norfolk Island',
    native: 'Norfolk Island',
    phone: '672',
    continent: 'OC',
    capital: 'Kingston',
    currency: 'AUD',
    languages: ['en'],
    code: 'NF',
  },
  {
    name: 'Nigeria',
    native: 'Nigeria',
    phone: '234',
    continent: 'AF',
    capital: 'Abuja',
    currency: 'NGN',
    languages: ['en'],
    code: 'NG',
  },
  {
    name: 'Nicaragua',
    native: 'Nicaragua',
    phone: '505',
    continent: 'NA',
    capital: 'Managua',
    currency: 'NIO',
    languages: ['es'],
    code: 'NI',
  },
  {
    name: 'Netherlands',
    native: 'Nederland',
    phone: '31',
    continent: 'EU',
    capital: 'Amsterdam',
    currency: 'EUR',
    languages: ['nl'],
    code: 'NL',
  },
  {
    name: 'Norway',
    native: 'Norge',
    phone: '47',
    continent: 'EU',
    capital: 'Oslo',
    currency: 'NOK',
    languages: ['no', 'nb', 'nn'],
    code: 'NO',
  },
  {
    name: 'Nepal',
    native: 'नपल',
    phone: '977',
    continent: 'AS',
    capital: 'Kathmandu',
    currency: 'NPR',
    languages: ['ne'],
    code: 'NP',
  },
  {
    name: 'Nauru',
    native: 'Nauru',
    phone: '674',
    continent: 'OC',
    capital: 'Yaren',
    currency: 'AUD',
    languages: ['en', 'na'],
    code: 'NR',
  },
  {
    name: 'Niue',
    native: 'Niuē',
    phone: '683',
    continent: 'OC',
    capital: 'Alofi',
    currency: 'NZD',
    languages: ['en'],
    code: 'NU',
  },
  {
    name: 'New Zealand',
    native: 'New Zealand',
    phone: '64',
    continent: 'OC',
    capital: 'Wellington',
    currency: 'NZD',
    languages: ['en', 'mi'],
    code: 'NZ',
  },
  {
    name: 'Oman',
    native: 'عمان',
    phone: '968',
    continent: 'AS',
    capital: 'Muscat',
    currency: 'OMR',
    languages: ['ar'],
    code: 'OM',
  },
  {
    name: 'Panama',
    native: 'Panamá',
    phone: '507',
    continent: 'NA',
    capital: 'Panama City',
    currency: 'PAB,USD',
    languages: ['es'],
    code: 'PA',
  },
  {
    name: 'Peru',
    native: 'Perú',
    phone: '51',
    continent: 'SA',
    capital: 'Lima',
    currency: 'PEN',
    languages: ['es'],
    code: 'PE',
  },
  {
    name: 'French Polynesia',
    native: 'Polynésie française',
    phone: '689',
    continent: 'OC',
    capital: 'Papeetē',
    currency: 'XPF',
    languages: ['fr'],
    code: 'PF',
  },
  {
    name: 'Papua New Guinea',
    native: 'Papua Niugini',
    phone: '675',
    continent: 'OC',
    capital: 'Port Moresby',
    currency: 'PGK',
    languages: ['en'],
    code: 'PG',
  },
  {
    name: 'Philippines',
    native: 'Pilipinas',
    phone: '63',
    continent: 'AS',
    capital: 'Manila',
    currency: 'PHP',
    languages: ['en'],
    code: 'PH',
  },
  {
    name: 'Pakistan',
    native: 'Pakistan',
    phone: '92',
    continent: 'AS',
    capital: 'Islamabad',
    currency: 'PKR',
    languages: ['en', 'ur'],
    code: 'PK',
  },
  {
    name: 'Poland',
    native: 'Polska',
    phone: '48',
    continent: 'EU',
    capital: 'Warsaw',
    currency: 'PLN',
    languages: ['pl'],
    code: 'PL',
  },
  {
    name: 'Saint Pierre and Miquelon',
    native: 'Saint-Pierre-et-Miquelon',
    phone: '508',
    continent: 'NA',
    capital: 'Saint-Pierre',
    currency: 'EUR',
    languages: ['fr'],
    code: 'PM',
  },
  {
    name: 'Pitcairn Islands',
    native: 'Pitcairn Islands',
    phone: '64',
    continent: 'OC',
    capital: 'Adamstown',
    currency: 'NZD',
    languages: ['en'],
    code: 'PN',
  },
  {
    name: 'Puerto Rico',
    native: 'Puerto Rico',
    phone: '1787,1939',
    continent: 'NA',
    capital: 'San Juan',
    currency: 'USD',
    languages: ['es', 'en'],
    code: 'PR',
  },
  {
    name: 'Palestine',
    native: 'فلسطين',
    phone: '970',
    continent: 'AS',
    capital: 'Ramallah',
    currency: 'ILS',
    languages: ['ar'],
    code: 'PS',
  },
  {
    name: 'Portugal',
    native: 'Portugal',
    phone: '351',
    continent: 'EU',
    capital: 'Lisbon',
    currency: 'EUR',
    languages: ['pt'],
    code: 'PT',
  },
  {
    name: 'Palau',
    native: 'Palau',
    phone: '680',
    continent: 'OC',
    capital: 'Ngerulmud',
    currency: 'USD',
    languages: ['en'],
    code: 'PW',
  },
  {
    name: 'Paraguay',
    native: 'Paraguay',
    phone: '595',
    continent: 'SA',
    capital: 'Asunción',
    currency: 'PYG',
    languages: ['es', 'gn'],
    code: 'PY',
  },
  {
    name: 'Qatar',
    native: 'قطر',
    phone: '974',
    continent: 'AS',
    capital: 'Doha',
    currency: 'QAR',
    languages: ['ar'],
    code: 'QA',
  },
  {
    name: 'Réunion',
    native: 'La Réunion',
    phone: '262',
    continent: 'AF',
    capital: 'Saint-Denis',
    currency: 'EUR',
    languages: ['fr'],
    code: 'RE',
  },
  {
    name: 'Romania',
    native: 'România',
    phone: '40',
    continent: 'EU',
    capital: 'Bucharest',
    currency: 'RON',
    languages: ['ro'],
    code: 'RO',
  },
  {
    name: 'Serbia',
    native: 'Србија',
    phone: '381',
    continent: 'EU',
    capital: 'Belgrade',
    currency: 'RSD',
    languages: ['sr'],
    code: 'RS',
  },
  {
    name: 'Russia',
    native: 'Россия',
    phone: '7',
    continent: 'EU',
    capital: 'Moscow',
    currency: 'RUB',
    languages: ['ru'],
    code: 'RU',
  },
  {
    name: 'Rwanda',
    native: 'Rwanda',
    phone: '250',
    continent: 'AF',
    capital: 'Kigali',
    currency: 'RWF',
    languages: ['rw', 'en', 'fr'],
    code: 'RW',
  },
  {
    name: 'Saudi Arabia',
    native: 'العربية السعودية',
    phone: '966',
    continent: 'AS',
    capital: 'Riyadh',
    currency: 'SAR',
    languages: ['ar'],
    code: 'SA',
  },
  {
    name: 'Solomon Islands',
    native: 'Solomon Islands',
    phone: '677',
    continent: 'OC',
    capital: 'Honiara',
    currency: 'SBD',
    languages: ['en'],
    code: 'SB',
  },
  {
    name: 'Seychelles',
    native: 'Seychelles',
    phone: '248',
    continent: 'AF',
    capital: 'Victoria',
    currency: 'SCR',
    languages: ['fr', 'en'],
    code: 'SC',
  },
  {
    name: 'Sudan',
    native: 'السودان',
    phone: '249',
    continent: 'AF',
    capital: 'Khartoum',
    currency: 'SDG',
    languages: ['ar', 'en'],
    code: 'SD',
  },
  {
    name: 'Sweden',
    native: 'Sverige',
    phone: '46',
    continent: 'EU',
    capital: 'Stockholm',
    currency: 'SEK',
    languages: ['sv'],
    code: 'SE',
  },
  {
    name: 'Singapore',
    native: 'Singapore',
    phone: '65',
    continent: 'AS',
    capital: 'Singapore',
    currency: 'SGD',
    languages: ['en', 'ms', 'ta', 'zh'],
    code: 'SG',
  },
  {
    name: 'Saint Helena',
    native: 'Saint Helena',
    phone: '290',
    continent: 'AF',
    capital: 'Jamestown',
    currency: 'SHP',
    languages: ['en'],
    code: 'SH',
  },
  {
    name: 'Slovenia',
    native: 'Slovenija',
    phone: '386',
    continent: 'EU',
    capital: 'Ljubljana',
    currency: 'EUR',
    languages: ['sl'],
    code: 'SI',
  },
  {
    name: 'Svalbard and Jan Mayen',
    native: 'Svalbard og Jan Mayen',
    phone: '4779',
    continent: 'EU',
    capital: 'Longyearbyen',
    currency: 'NOK',
    languages: ['no'],
    code: 'SJ',
  },
  {
    name: 'Slovakia',
    native: 'Slovensko',
    phone: '421',
    continent: 'EU',
    capital: 'Bratislava',
    currency: 'EUR',
    languages: ['sk'],
    code: 'SK',
  },
  {
    name: 'Sierra Leone',
    native: 'Sierra Leone',
    phone: '232',
    continent: 'AF',
    capital: 'Freetown',
    currency: 'SLL',
    languages: ['en'],
    code: 'SL',
  },
  {
    name: 'San Marino',
    native: 'San Marino',
    phone: '378',
    continent: 'EU',
    capital: 'City of San Marino',
    currency: 'EUR',
    languages: ['it'],
    code: 'SM',
  },
  {
    name: 'Senegal',
    native: 'Sénégal',
    phone: '221',
    continent: 'AF',
    capital: 'Dakar',
    currency: 'XOF',
    languages: ['fr'],
    code: 'SN',
  },
  {
    name: 'Somalia',
    native: 'Soomaaliya',
    phone: '252',
    continent: 'AF',
    capital: 'Mogadishu',
    currency: 'SOS',
    languages: ['so', 'ar'],
    code: 'SO',
  },
  {
    name: 'Suriname',
    native: 'Suriname',
    phone: '597',
    continent: 'SA',
    capital: 'Paramaribo',
    currency: 'SRD',
    languages: ['nl'],
    code: 'SR',
  },
  {
    name: 'South Sudan',
    native: 'South Sudan',
    phone: '211',
    continent: 'AF',
    capital: 'Juba',
    currency: 'SSP',
    languages: ['en'],
    code: 'SS',
  },
  {
    name: 'São Tomé and Príncipe',
    native: 'São Tomé e Príncipe',
    phone: '239',
    continent: 'AF',
    capital: 'São Tomé',
    currency: 'STN',
    languages: ['pt'],
    code: 'ST',
  },
  {
    name: 'El Salvador',
    native: 'El Salvador',
    phone: '503',
    continent: 'NA',
    capital: 'San Salvador',
    currency: 'SVC,USD',
    languages: ['es'],
    code: 'SV',
  },
  {
    name: 'Sint Maarten',
    native: 'Sint Maarten',
    phone: '1721',
    continent: 'NA',
    capital: 'Philipsburg',
    currency: 'ANG',
    languages: ['nl', 'en'],
    code: 'SX',
  },
  {
    name: 'Syria',
    native: 'سوريا',
    phone: '963',
    continent: 'AS',
    capital: 'Damascus',
    currency: 'SYP',
    languages: ['ar'],
    code: 'SY',
  },
  {
    name: 'Swaziland',
    native: 'Swaziland',
    phone: '268',
    continent: 'AF',
    capital: 'Lobamba',
    currency: 'SZL',
    languages: ['en', 'ss'],
    code: 'SZ',
  },
  {
    name: 'Turks and Caicos Islands',
    native: 'Turks and Caicos Islands',
    phone: '1649',
    continent: 'NA',
    capital: 'Cockburn Town',
    currency: 'USD',
    languages: ['en'],
    code: 'TC',
  },
  {
    name: 'Chad',
    native: 'Tchad',
    phone: '235',
    continent: 'AF',
    capital: "N'Djamena",
    currency: 'XAF',
    languages: ['fr', 'ar'],
    code: 'TD',
  },
  {
    name: 'French Southern Territories',
    native: 'Territoire des Terres australes et antarctiques fr',
    phone: '262',
    continent: 'AN',
    capital: 'Port-aux-Français',
    currency: 'EUR',
    languages: ['fr'],
    code: 'TF',
  },
  {
    name: 'Togo',
    native: 'Togo',
    phone: '228',
    continent: 'AF',
    capital: 'Lomé',
    currency: 'XOF',
    languages: ['fr'],
    code: 'TG',
  },
  {
    name: 'Thailand',
    native: 'ประเทศไทย',
    phone: '66',
    continent: 'AS',
    capital: 'Bangkok',
    currency: 'THB',
    languages: ['th'],
    code: 'TH',
  },
  {
    name: 'Tajikistan',
    native: 'Тоҷикистон',
    phone: '992',
    continent: 'AS',
    capital: 'Dushanbe',
    currency: 'TJS',
    languages: ['tg', 'ru'],
    code: 'TJ',
  },
  {
    name: 'Tokelau',
    native: 'Tokelau',
    phone: '690',
    continent: 'OC',
    capital: 'Fakaofo',
    currency: 'NZD',
    languages: ['en'],
    code: 'TK',
  },
  {
    name: 'East Timor',
    native: 'Timor-Leste',
    phone: '670',
    continent: 'OC',
    capital: 'Dili',
    currency: 'USD',
    languages: ['pt'],
    code: 'TL',
  },
  {
    name: 'Turkmenistan',
    native: 'Türkmenistan',
    phone: '993',
    continent: 'AS',
    capital: 'Ashgabat',
    currency: 'TMT',
    languages: ['tk', 'ru'],
    code: 'TM',
  },
  {
    name: 'Tunisia',
    native: 'تونس',
    phone: '216',
    continent: 'AF',
    capital: 'Tunis',
    currency: 'TND',
    languages: ['ar'],
    code: 'TN',
  },
  {
    name: 'Tonga',
    native: 'Tonga',
    phone: '676',
    continent: 'OC',
    capital: "Nuku'alofa",
    currency: 'TOP',
    languages: ['en', 'to'],
    code: 'TO',
  },
  {
    name: 'Turkey',
    native: 'Türkiye',
    phone: '90',
    continent: 'AS',
    capital: 'Ankara',
    currency: 'TRY',
    languages: ['tr'],
    code: 'TR',
  },
  {
    name: 'Trinidad and Tobago',
    native: 'Trinidad and Tobago',
    phone: '1868',
    continent: 'NA',
    capital: 'Port of Spain',
    currency: 'TTD',
    languages: ['en'],
    code: 'TT',
  },
  {
    name: 'Tuvalu',
    native: 'Tuvalu',
    phone: '688',
    continent: 'OC',
    capital: 'Funafuti',
    currency: 'AUD',
    languages: ['en'],
    code: 'TV',
  },
  {
    name: 'Taiwan',
    native: '臺灣',
    phone: '886',
    continent: 'AS',
    capital: 'Taipei',
    currency: 'TWD',
    languages: ['zh'],
    code: 'TW',
  },
  {
    name: 'Tanzania',
    native: 'Tanzania',
    phone: '255',
    continent: 'AF',
    capital: 'Dodoma',
    currency: 'TZS',
    languages: ['sw', 'en'],
    code: 'TZ',
  },
  {
    name: 'Ukraine',
    native: 'Україна',
    phone: '380',
    continent: 'EU',
    capital: 'Kyiv',
    currency: 'UAH',
    languages: ['uk'],
    code: 'UA',
  },
  {
    name: 'Uganda',
    native: 'Uganda',
    phone: '256',
    continent: 'AF',
    capital: 'Kampala',
    currency: 'UGX',
    languages: ['en', 'sw'],
    code: 'UG',
  },
  {
    name: 'U.S. Minor Outlying Islands',
    native: 'United States Minor Outlying Islands',
    phone: '1',
    continent: 'OC',
    capital: '',
    currency: 'USD',
    languages: ['en'],
    code: 'UM',
  },
  {
    name: 'United States',
    native: 'United States',
    phone: '1',
    continent: 'NA',
    capital: 'Washington D.C.',
    currency: 'USD,USN,USS',
    languages: ['en'],
    code: 'US',
  },
  {
    name: 'Uruguay',
    native: 'Uruguay',
    phone: '598',
    continent: 'SA',
    capital: 'Montevideo',
    currency: 'UYI,UYU',
    languages: ['es'],
    code: 'UY',
  },
  {
    name: 'Uzbekistan',
    native: 'O‘zbekiston',
    phone: '998',
    continent: 'AS',
    capital: 'Tashkent',
    currency: 'UZS',
    languages: ['uz', 'ru'],
    code: 'UZ',
  },
  {
    name: 'Vatican City',
    native: 'Vaticano',
    phone: '379',
    continent: 'EU',
    capital: 'Vatican City',
    currency: 'EUR',
    languages: ['it', 'la'],
    code: 'VA',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    native: 'Saint Vincent and the Grenadines',
    phone: '1784',
    continent: 'NA',
    capital: 'Kingstown',
    currency: 'XCD',
    languages: ['en'],
    code: 'VC',
  },
  {
    name: 'Venezuela',
    native: 'Venezuela',
    phone: '58',
    continent: 'SA',
    capital: 'Caracas',
    currency: 'VES',
    languages: ['es'],
    code: 'VE',
  },
  {
    name: 'British Virgin Islands',
    native: 'British Virgin Islands',
    phone: '1284',
    continent: 'NA',
    capital: 'Road Town',
    currency: 'USD',
    languages: ['en'],
    code: 'VG',
  },
  {
    name: 'U.S. Virgin Islands',
    native: 'United States Virgin Islands',
    phone: '1340',
    continent: 'NA',
    capital: 'Charlotte Amalie',
    currency: 'USD',
    languages: ['en'],
    code: 'VI',
  },
  {
    name: 'Vietnam',
    native: 'Việt Nam',
    phone: '84',
    continent: 'AS',
    capital: 'Hanoi',
    currency: 'VND',
    languages: ['vi'],
    code: 'VN',
  },
  {
    name: 'Vanuatu',
    native: 'Vanuatu',
    phone: '678',
    continent: 'OC',
    capital: 'Port Vila',
    currency: 'VUV',
    languages: ['bi', 'en', 'fr'],
    code: 'VU',
  },
  {
    name: 'Wallis and Futuna',
    native: 'Wallis et Futuna',
    phone: '681',
    continent: 'OC',
    capital: 'Mata-Utu',
    currency: 'XPF',
    languages: ['fr'],
    code: 'WF',
  },
  {
    name: 'Samoa',
    native: 'Samoa',
    phone: '685',
    continent: 'OC',
    capital: 'Apia',
    currency: 'WST',
    languages: ['sm', 'en'],
    code: 'WS',
  },
  {
    name: 'Kosovo',
    native: 'Republika e Kosovës',
    phone: '377,381,383,386',
    continent: 'EU',
    capital: 'Pristina',
    currency: 'EUR',
    languages: ['sq', 'sr'],
    code: 'XK',
  },
  {
    name: 'Yemen',
    native: 'اليَمَن',
    phone: '967',
    continent: 'AS',
    capital: "Sana'a",
    currency: 'YER',
    languages: ['ar'],
    code: 'YE',
  },
  {
    name: 'Mayotte',
    native: 'Mayotte',
    phone: '262',
    continent: 'AF',
    capital: 'Mamoudzou',
    currency: 'EUR',
    languages: ['fr'],
    code: 'YT',
  },
  {
    name: 'South Africa',
    native: 'South Africa',
    phone: '27',
    continent: 'AF',
    capital: 'Pretoria',
    currency: 'ZAR',
    languages: ['af', 'en', 'nr', 'st', 'ss', 'tn', 'ts', 've', 'xh', 'zu'],
    code: 'ZA',
  },
  {
    name: 'Zambia',
    native: 'Zambia',
    phone: '260',
    continent: 'AF',
    capital: 'Lusaka',
    currency: 'ZMW',
    languages: ['en'],
    code: 'ZM',
  },
  {
    name: 'Zimbabwe',
    native: 'Zimbabwe',
    phone: '263',
    continent: 'AF',
    capital: 'Harare',
    currency: 'USD,ZAR,BWP,GBP,AUD,CNY,INR,JPY',
    languages: ['en', 'sn', 'nd'],
    code: 'ZW',
  },
];
